/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import TagType from './TagType';

/**
 * The TagLink model module.
 * @module model/TagLink
 * @version V1
 */
class TagLink {
    /**
     * Constructs a new <code>TagLink</code>.
     * @alias module:model/TagLink
     */
    constructor() { 
        
        TagLink.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>TagLink</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/TagLink} obj Optional instance to populate.
     * @return {module:model/TagLink} The populated <code>TagLink</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new TagLink();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('accountId')) {
                obj['accountId'] = ApiClient.convertToType(data['accountId'], 'Number');
            }
            if (data.hasOwnProperty('tagId')) {
                obj['tagId'] = ApiClient.convertToType(data['tagId'], 'Number');
            }
            if (data.hasOwnProperty('taggedItemId')) {
                obj['taggedItemId'] = ApiClient.convertToType(data['taggedItemId'], 'Number');
            }
            if (data.hasOwnProperty('tagType')) {
                obj['tagType'] = TagType.constructFromObject(data['tagType']);
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>TagLink</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>TagLink</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Number} id
 */
TagLink.prototype['id'] = undefined;

/**
 * @member {Number} accountId
 */
TagLink.prototype['accountId'] = undefined;

/**
 * @member {Number} tagId
 */
TagLink.prototype['tagId'] = undefined;

/**
 * @member {Number} taggedItemId
 */
TagLink.prototype['taggedItemId'] = undefined;

/**
 * @member {module:model/TagType} tagType
 */
TagLink.prototype['tagType'] = undefined;

/**
 * @member {Date} createdAt
 */
TagLink.prototype['createdAt'] = undefined;






export default TagLink;

